<ng-container *ngIf="alert$ | async as alert">

  <app-core-modal
    [isOpen]="alert.isOpen"
    [title]="alert.title"
    [showFooter]="false"
    [isAlert]="true"
    (close)="close()"
  >
    <div class="alert-icon" [class]="{'error': alert.type === 'error'}">
      <fa-icon [icon]="alertIcon[alert.type]"></fa-icon>
    </div>
    <div class="alert-message" [innerHTML]="alert.message"></div>

    <div class="alert-footer">

      <app-core-button
        *ngIf="alert.type === 'confirm'"
        label="Cancelar"
        variant="secondary"
        (click)="cancel()">
      </app-core-button>

      <app-core-button
        label="Aceptar"
        [variant]="alert.type === 'error'? 'danger' : 'primary'"
        (click)="accept()">
      </app-core-button>

    </div>

  </app-core-modal>

</ng-container>
